import React, { memo } from "react";

const IconLock = (props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 21 24" fill="none">
    <path
      d="M10.5 15.5V17.4091M6.24138 10.4091V5.63636C6.24138 3.35191 8.14803 1.5 10.5 1.5C12.852 1.5 14.7586 3.35191 14.7586 5.63636V10.4091M6.24138 10.4091H3.62069C2.17332 10.4091 1 11.5487 1 12.9545V19.9545C1 21.3604 2.17332 22.5 3.62069 22.5H17.3793C18.8267 22.5 20 21.3604 20 19.9545V12.9545C20 11.5487 18.8267 10.4091 17.3793 10.4091H14.7586M6.24138 10.4091H14.7586"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(IconLock);
